import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';
export const AiAnswerFeedbackPage = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "ai-answer-feedback-page" */ './hocs')),
});
